<template>
    <div class="dropdown-menu" :class="'dropdown-menu-' + drop_key.replace('/', '')">
        <div class="menu-container" v-if="drop_key == '/about'">
            <div class="menu-item" v-for="item in setup.main_page_nav_drop.about.nav">
                <router-link :to="item.menu.link" @click.native="removeLoader">
                    <h5 v-if="item.title != ''">{{ item.title }}</h5>
                    <h4>{{ item.menu.name }}</h4>
                    <div class="menu-icon"><img :src="item.icon" alt=""></div>
                </router-link>
            </div>
        </div>
        <div class="menu-container" v-if="drop_key == '/activites'">
            <div class="menu-item" v-for="item in setup.main_page_nav_drop.activity.nav">
                <router-link :to="item.menu.link">
                    <h5 v-if="item.title != ''">{{ item.title }}</h5>
                    <h4 v-html="item.menu.name"></h4>
                    <div class="menu-icon"><img :src="item.icon" alt=""></div>
                </router-link>
            </div>
        </div>
        <div class="menu-container" v-if="drop_key == '/news'">
            <div class="menu-item" v-for="item in setup.main_page_nav_drop.news.nav">
                <router-link :to="item.menu.link">
                    <h5 v-if="item.title != ''">{{ item.title }}</h5>
                    <h4>{{ item.menu.name }}</h4>
                    <div class="menu-icon"><img :src="item.icon" alt=""></div>
                </router-link>
            </div>
        </div>
        <div class="menu-container" v-if="drop_key == '/projects'">
            <div class="menu-item" v-for="item in setup.main_page_nav_drop.projects.nav">
                <router-link :to="item.menu.link">
                    <h5 v-if="item.title != ''">{{ item.title }}</h5>
                    <h4>{{ item.menu.name }}</h4>
                    <div class="menu-icon"><img :src="item.icon" alt=""></div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'nav-main',
        props: ['drop_key'],
        data () {
            return {
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
        }),
        methods: {
            removeLoader() {
                setTimeout(() => {
                    this.$parent.$parent.$parent.$parent.$refs.topProgress.done()
                }, 300);
            },  
            // startLoader(href) {
            //     if (href == '/partners') {
            //         window.open('https://portal.bazis.kz', '_blank');
            //     } else {
            //         this.$parent.$parent.$refs.topProgress.start();
            //     }
            // }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/drop-nav.scss';
</style>